import styled from "styled-components"

const Title = styled.h2`
  text-align: center;
  font-weight: bold;
`

export default Title